export const sliceNumberFromString = (text: string) => {
  //   ?=== sample ===
  // === "ABC1234" => ["ABC","1234"] ===
  var sliceText = text.split(/(\d+)/);
  //   === filter empty string ===
  sliceText = sliceText.filter((t: string) => t !== "");
  return sliceText;
};
